import { SiGithub } from "@icons-pack/react-simple-icons";

interface VcsIntegration {
  platform: string;
  org_name: string | null;
  connected_at: string;
}

interface GithubIntegrationSectionProps {
  vcsIntegration: VcsIntegration | null;
  canEdit: boolean;
  workspaceSlug: string;
  onDisconnect: () => void;
}

export function GithubIntegrationSection({
  vcsIntegration,
  canEdit,
  workspaceSlug,
  onDisconnect,
}: GithubIntegrationSectionProps) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-2.5">
        <SiGithub className="w-4 h-4 text-gray-600 dark:text-gray-400" />
        <div>
          <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
            GitHub
          </h3>
          {vcsIntegration ? (
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Connected to{" "}
              <a
                href={`https://github.com/${vcsIntegration.org_name}`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary hover:underline"
              >
                {vcsIntegration.org_name}
              </a>
            </p>
          ) : (
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Connect your GitHub organization to create pull requests
            </p>
          )}
        </div>
      </div>
      {vcsIntegration ? (
        <button
          onClick={onDisconnect}
          disabled={!canEdit}
          className="inline-flex items-center px-3 py-1.5 border border-gray-300 dark:border-gray-600 text-xs font-medium rounded-full text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
        >
          Disconnect
        </button>
      ) : (
        <a
          href={`/vcs_integrations/github/connect?state=${workspaceSlug}`}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full whitespace-nowrap transition-colors ${
            canEdit
              ? "bg-primary text-white hover:bg-primary/90"
              : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed pointer-events-none"
          }`}
        >
          <SiGithub className="w-3.5 h-3.5" />
          Connect GitHub
        </a>
      )}
    </div>
  );
}
